// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { createSelector } from 'reselect';

import { RootState } from '../../rootReducer';
import { SupportStateType } from '../../../types/Model';

export const supportStatusRaw = (state: RootState) => state.updateSupportStatusReducer;

export const makeUpdateSupportStatusSelector = () => {
  return createSelector(
    supportStatusRaw,
    (updateSupportStatusReducer) => updateSupportStatusReducer.supportStatus || SupportStateType.Closed
  );
}
export const makeUpdateSupportStatusError = () => {
  return createSelector(
    supportStatusRaw,
    (updateSupportStatusReducer) => updateSupportStatusReducer.error
  );
}

export const makeUpdateSupportStatusIsLoading = () => {
  return createSelector(
    supportStatusRaw,
    (updateSupportStatusReducer) => updateSupportStatusReducer.isLoading
  );
}
